import { Grid } from '@mui/material'
import { Container } from '@mui/system'
import React from 'react'
import { Heading, P, SectionWrapper } from '../../Styles/style'
import tokenomicsImg from "../../../assets/tokenomics.png"
import WorksCard from './Card'
import styled from '@emotion/styled'

const TokenomicsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border: 1px solid #000;
  box-shadow: 1px 3px 9px 0px #00000039;
  font-family: "Poppins-Bold";
  padding: 12px 10px;
  margin: 20px 0;
  border-radius: 10px;
  margin-right: ${props=> props.mr ? props.mr : '0px'};
  margin-left: ${props=> props.ml ? props.ml : '0px'};
  @media screen and (max-width:1250px){
  margin-right: ${props=> props.mr1250 ? props.mr1250 : ''};
  margin-left: ${props=> props.ml1250 ? props.ml1250 : ''};
}
  @media screen and (max-width:599px){
  margin-right: ${props=> props.mr599 ? props.mr599 : '0px'};
  margin-left: ${props=> props.ml599 ? props.ml599 : '0px'};
}
`
const Tokenomicsheading = styled.div`
color: #BA51FF;
  font-family: "Poppins-Bold";
`
const TokenomicsValue = styled.div`
font-family: "Poppins-Bold";
`
const TokenomicsImgdog = styled.img`
width: 100%;
height: auto;
max-width: 200px;
`
const Works = () => {
  return (
    <SectionWrapper p="3rem 0" id="tokenomics">
      <Container>
        <Grid container >
          <Grid xs={12}>
            <Heading fs="58px" align="center" m="3.5rem 0 0.5rem 0">Tokenomics</Heading>
         </Grid>
        </Grid>
        <Grid container style={{padding:"50px 0"}}>
         <Grid item xs={12} sm={4}>
         <TokenomicsWrapper>
          <Tokenomicsheading>Name</Tokenomicsheading>
          <TokenomicsValue>Sanshu Inu</TokenomicsValue>
         </TokenomicsWrapper>
         <TokenomicsWrapper mr="50px" ml="-50px" mr1250="15px" ml1250="-15px">
          <Tokenomicsheading>Symbol</Tokenomicsheading>
          <TokenomicsValue>Sanshu</TokenomicsValue>
         </TokenomicsWrapper>
         <TokenomicsWrapper>
          <Tokenomicsheading>Supply</Tokenomicsheading>
          <TokenomicsValue>1,000,000,000,000</TokenomicsValue>
         </TokenomicsWrapper>

         </Grid>
         <Grid item xs={12} sm={4} style={{textAlignLast:"center"}}>
          <TokenomicsImgdog src={tokenomicsImg} />
         </Grid>
         <Grid item xs={12} sm={4}>
         <TokenomicsWrapper>
          <Tokenomicsheading>Slippage</Tokenomicsheading>
          <TokenomicsValue>5-10%</TokenomicsValue>
         </TokenomicsWrapper>
         <TokenomicsWrapper mr="-50px" ml="50px" mr1250="-15px" ml1250="15px">
          <Tokenomicsheading>Buy Tax</Tokenomicsheading>
          <TokenomicsValue>5</TokenomicsValue>
         </TokenomicsWrapper>
         <TokenomicsWrapper>
          <Tokenomicsheading>Sell Tax</Tokenomicsheading>
          <TokenomicsValue>5</TokenomicsValue>
         </TokenomicsWrapper>
         </Grid>
        </Grid>
      </Container>
    </SectionWrapper>
  )
}

export default Works